import React, { useMemo, type ReactNode, type ComponentType } from 'react';
import { createHtmlPortalNode, InPortal, OutPortal } from 'react-reverse-portal';
import { Layering } from '@atlaskit/layering';

export type ReParenterProps = {
	children?: ReactNode;
	Parent: ComponentType<{
		children?: ReactNode;
	}>;
};

/**
 * When you change the parent of a component (reparent) this changes the React tree and thus causes a remount of the children
 * This causes state of children to be lost, as well as causing us to incur the cost of remounting the child
 * which can be very expensive and cause performance issues
 *
 * This component uses react-reverse-portal to allow us to reparent without remounting
 * therefore bypassing state loss and performance concerns
 */

export const ReParenter = ({ children, Parent }: ReParenterProps) => {
	const portalNode = useMemo(() => createHtmlPortalNode(), []);
	return (
		<>
			<InPortal node={portalNode}>
				<Layering isDisabled={false}>{children}</Layering>
			</InPortal>
			<Parent>
				<OutPortal node={portalNode} />
			</Parent>
		</>
	);
};
